export default {
  DELETE: 'DELETE',
  DELETE_PUBLISHED: 'DELETE_PUBLISHED',
  SAVE: 'SAVE',
  VALIDATE_CATALOGS: 'VALIDATE_CATALOGS',
  CREATE_IN_GLUP: 'CREATE_IN_GLUP',
};
